// extracted by mini-css-extract-plugin
export default {"nav":"navigation_nav__e0Yt7","logo":"navigation_logo__VavNt","navList":"navigation_navList__7T8dm","link":"navigation_link__IWtF3"};